import React, {useEffect, useRef, useState} from "react"
import {
  createSimulator,
  downloadData,
  getAllDataSpace,
  getDataByDataSpace,
  getMetadataByDataSpace,
  updateMetadata
} from "../../api/DataAPI"
import {Button, IconButton, Input, Option, Select, Switch, Textarea} from "@material-tailwind/react"
import {ArrowLeftIcon, ArrowRightIcon} from "@heroicons/react/24/outline"
import {CreateDataSpaceDialog} from "../../components/Simulator/CreateDataSpaceDialog"
import {AddDataDialog} from "../../components/Simulator/AddDataDialog"

export default function Simulator() {

  const PAGE_SIZE = 10
  const PAGE_WINDOW_SIZE = 3

  const [dataspace, setDataspace] = useState('')
  const [dataspaceList, setDataspaceList] = useState([])
  const [metadata, setMetadata] = useState('')
  const [modifyMetadata, setModifyMetadata] = useState(true)
  const [data, setData] = useState([])
  const [dataSearchText, setDataSearchText] = useState('')
  const [simulatorCount, setSimulatorCount] = useState(0)

  const [currentDataInformation, setCurrentDataInformation] = useState({'data': [], 'page': 1, 'pageList': []})

  useEffect(() => {
    getAllDataSpace()
      .then(res => setDataspaceList(res.data))
      .catch(err => console.log(err))
  }, [])

  useEffect(() => {
    handleDataInformation({'data': data.slice(0, PAGE_SIZE), 'page': 1, 'pageList': []})
    //eslint-disable-next-line
  }, [data])

  useEffect(() => {
    handleDataInformation(currentDataInformation)
    //eslint-disable-next-line
  }, [dataSearchText])

  const createDataNameDialogRef = useRef()
  const addDataDialogRef = useRef()

  const handleDataInformation = (dataInformation) => {
    let newPageList = []

    if (dataInformation['page'] >= PAGE_WINDOW_SIZE) {
      newPageList.push(dataInformation['page'] - 2)
      newPageList.push(dataInformation['page'] - 1)
    } else if (dataInformation['page'] >= PAGE_WINDOW_SIZE - 1) {
      newPageList.push(dataInformation['page'] - 1)
    }

    newPageList.push(dataInformation['page'])

    let lastPage = Math.ceil(data.filter(x => x.includes(dataSearchText)).length / PAGE_SIZE)
    if (dataInformation['page'] <= lastPage - PAGE_WINDOW_SIZE + 1) {
      newPageList.push(dataInformation['page'] + 1)
      newPageList.push(dataInformation['page'] + 2)
    } else if (dataInformation['page'] <= lastPage - PAGE_WINDOW_SIZE + 2) {
      newPageList.push(dataInformation['page'] + 1)
    }

    setCurrentDataInformation({
      ...dataInformation,
      'data': data.filter(x => x.includes(dataSearchText)).slice(dataInformation['page'] * PAGE_SIZE - PAGE_SIZE, dataInformation['page'] * PAGE_SIZE),
      'pageList': newPageList
    })
  }

  const handleSelectDataSpace = (e) => {
    getMetadataByDataSpace(e)
      .then(res => setMetadata(JSON.stringify(res.data, undefined, 4)))
      .catch(err => console.log(err))
    getDataByDataSpace(e)
      .then(res => setData(res.data))
      .catch(err => console.log(err))
    setDataspace(e)
  }

  const handleMetadataUpdate = () => {
    try {
      JSON.parse(metadata)
    } catch (e) {
      alert(e.toString())
      return
    }

    updateMetadata(dataspace, metadata)
      .then(res => console.log(res.data))
      .catch(err => console.log(err))
  }

  const handleCreateSimulator = () => {
    createSimulator(simulatorCount)
      .then(() => alert("Request Success!"))
      .catch(err => console.log(err))
  }

  const PageItems = () => {
    let lastPage = Math.ceil(data.length / PAGE_SIZE)

    return (
      <div className="flex items-center gap-4 justify-center pt-4">
        <Button
          variant="text"
          className="flex items-center gap-2 rounded-full"
          onClick={() => handleDataInformation({...currentDataInformation, 'page': 1})}
          disabled={currentDataInformation['page'] === 1}
        >
          <ArrowLeftIcon strokeWidth={2} className="h-4 w-4"/> First
        </Button>

        {
          <div className="flex items-center gap-2">
            {
              currentDataInformation['pageList'].map((page, idx) => (
                <div key={idx}>
                  {page === currentDataInformation['page'] &&
                    <IconButton className={"rounded-full"}
                                value={page}
                                onClick={(e) => handleDataInformation({
                                  ...currentDataInformation,
                                  'page': parseInt(e.target.innerText)
                                })}
                                disabled>
                      {page}
                    </IconButton>}
                  {page !== currentDataInformation['page'] &&
                    <IconButton className={"rounded-full"}
                                value={page}
                                onClick={(e) => handleDataInformation({
                                  ...currentDataInformation,
                                  'page': parseInt(e.target.innerText)
                                })}>
                      {page}
                    </IconButton>}
                </div>
              ))
            }
          </div>
        }

        <Button
          variant="text"
          className="flex items-center gap-2 rounded-full"
          onClick={() => handleDataInformation({...currentDataInformation, 'page': parseInt(lastPage)})}
          disabled={currentDataInformation['page'] === lastPage}
        >
          Last
          <ArrowRightIcon strokeWidth={2} className="h-4 w-4"/>
        </Button>
      </div>
    )
  }

  return (
    <>
      <CreateDataSpaceDialog ref={createDataNameDialogRef} rerender={() => window.location.reload()}/>
      <AddDataDialog ref={addDataDialogRef} dataspace={dataspace}/>

      <div className="flex flex-col h-[80vh] m-6 overflow-auto">
        <div className="flex pt-1 pb-6">
          <div className={"pr-2"}>
            <Select onChange={handleSelectDataSpace} label="Select Dataspace">
              {
                dataspaceList.map((item, idx) => {
                  return <Option key={idx} value={item}>{item}</Option>
                })
              }
            </Select>
          </div>

          <div className={"pr-2"}>
            <Button onClick={() => createDataNameDialogRef.current.openDialog()} variant="gradient">
              Create new data space
            </Button>
          </div>
          <div className={"pr-2"}>
            <Input label="Simulator Count"
                   value={simulatorCount}
                   onChange={(e) => setSimulatorCount(e.target.value)}/>
          </div>
          <div>
            <Button onClick={handleCreateSimulator} variant="gradient">
              Create simulator
            </Button>
          </div>
        </div>

        <div>
          <div className={"flex items-center mb-2"}>
            <h1 className={"text-xl font-bold mr-4"}>Metadata</h1>
            <Switch color="red" label="Modify" onChange={() => setModifyMetadata(!modifyMetadata)}/>
            <Button className={"ml-4"} color="red" onClick={handleMetadataUpdate} disabled={modifyMetadata}>
              Update
            </Button>
          </div>
          <Textarea className={"h-60 min-h-[220px]"}
                    value={metadata}
                    disabled={modifyMetadata}
                    onChange={(e) => setMetadata(e.target.value)}/>
        </div>

        <div className={"mt-5"}>
          <div className={"flex items-center mb-2"}>
            <h1 className={"text-xl font-bold"}>Data List</h1>
            <Button color={"cyan"}
                    className={"ml-5"}
                    onClick={() => addDataDialogRef.current.openDialog()}
                    disabled={dataspace === ''}>
              Add Data
            </Button>
          </div>

          <div className={"w-full border-separate rounded-[20px] overflow-hidden bg-amber-50 pb-2"}>
            <div className="flex w-full font-bold pb-3 sticky py-3 border-b-2">
              <div className="flex justify-center text-center w-1/2">
                <p className={"my-auto mr-3"}>Data</p>
                <div className={"w-72"}>
                  <Input label="Search" onChange={(e) => setDataSearchText(e.target.value)}/>
                </div>
              </div>
              <div className="inline-block w-0.5 bg-neutral-100 opacity-100 dark:opacity-50"></div>
              <div className="my-auto text-center w-1/2">
                <p>Download</p>
              </div>
            </div>

            {
              currentDataInformation['data'].map((item, idx) => {
                return <div key={idx}>
                  <hr className="h-0.5 border-t-0 bg-neutral-100 opacity-100 dark:opacity-50"/>
                  <div className="flex w-full text-sm">
                    <div className="p-1 w-1/2 m-auto pl-10">
                      {item}
                    </div>
                    <div className="p-1 w-1/2 text-center">
                      <Button color="blue" onClick={() => downloadData(item)}>
                        Download
                      </Button>
                    </div>
                  </div>
                </div>
              })
            }
          </div>
        </div>

        <div>
          <PageItems/>
        </div>
      </div>
    </>
  )
}
